import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaImpressoesDoDia } from "./components/TabelaImpressoesDoDia"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Impressões do Dia" />
            <TabelaImpressoesDoDia />
        </>
    )
}
